import { Medal } from "@phosphor-icons/react";

const TOP = {
  1: "bg-amber-100 text-amber-600 ring-1 ring-amber-300",
  2: "bg-slate-200 text-slate-500 ring-1 ring-slate-300",
  3: "bg-orange-100 text-orange-600 ring-1 ring-orange-300",
};

export default function RankBadge({ rank }) {
  if (!rank) return null;
  if (rank <= 3) {
    return (
      <span title={`Rank ${rank}`} className={`ml-1.5 inline-flex h-[18px] w-[18px] items-center justify-center rounded-full align-middle ${TOP[rank]}`}>
        <Medal size={11} weight="fill" />
      </span>
    );
  }
  if (rank <= 10) {
    return (
      <span title={`Rank ${rank}`} className="ml-1.5 inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-slate-100 px-1 align-middle text-[10px] font-bold text-slate-500">
        {rank}
      </span>
    );
  }
  return <span className="ml-1 align-middle text-[10px] text-slate-400">#{rank}</span>;
}

// Compute independent ranks (1 = highest) for each field, from the ORIGINAL row set.
export function computeRanks(rows, fields) {
  const ranks = {};
  for (const f of fields) {
    const ordered = [...rows]
      .filter((r) => r[f] != null)
      .sort((a, b) => b[f] - a[f]);
    ranks[f] = {};
    ordered.forEach((r, i) => { ranks[f][r.name] = i + 1; });
  }
  return ranks;
}
